<div class="select-catchup-team-context"
     *adaptLoading="!catchup">
    @if (isSelectTeamVisible && showSelectionLabel) {
        <label class="context-selector-header"
               for="selectTeam">
            Team
            <span class="fal fa-info-circle"
                  adaptTooltip="The team selection determines if this Peer Catch-up is limited to a specific team or across all teams. Selecting a specific team may also further limit who can view the Peer Catch-up."></span>
        </label>
    }

    <div class="context-selector-row">
        @switch (!!catchup!.team) {
            @case (true) {
                <i class="fal fa-fw fa-2x fa-users"
                   aria-hidden="true"></i>
            }
            @default {
                <i class="fal fa-fw fa-2x fa-cubes"
                   aria-hidden="true"></i>
            }
        }
        @if (isEditing) {
            <adapt-select-common-team id="selectTeam"
                                      class="context-selector"
                                      [person1]="catchup!.person1"
                                      [person2]="catchup!.person2"
                                      [team]="catchup!.team"
                                      (teamChange)="onTeamSelection($event!)"
                                      (commonTeamsChange)="setHasCommonTeams($event)"></adapt-select-common-team>
        }

        @if (isEditing && !validationStates.hasCommonTeams) {
            <div class="alert alert-warning">
                This Peer Catch-up is for all teams.
                <span class="fal fa-info-circle"
                      adaptTooltip="{{ catchup!.person1?.fullName }} and {{ catchup!.person2?.fullName }} do not share membership of any teams, so this Peer Catch-up must be across all teams."></span>
            </div>
        }

        @if (!isEditing && catchup!.team) {
            <p>
                This Peer Catch-up is limited to the
                <adapt-link-team [team]="catchup!.team"></adapt-link-team>
                Team.
            </p>
        }

        @if (!isEditing && !catchup?.team) {
            <p>This Peer Catch-up is for all teams.</p>
        }

        @if (isValidSelection) {
            <adapt-display-catchup-visibility class="ms-2"
                                              [catchup]="catchup"></adapt-display-catchup-visibility>
        }
    </div>
    @if (invalidTeamMessage) {
        <div class="alert alert-danger">
            {{ invalidTeamMessage }}
        </div>
    }
</div>
